/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Just_MeInputs */

const en_common_just_me = /** @type {(inputs: Common_Just_MeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Just me`)
};

const es_common_just_me = /** @type {(inputs: Common_Just_MeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Solo yo`)
};

/**
* | output |
* | --- |
* | "Just me" |
*
* @param {Common_Just_MeInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const common_just_me = /** @type {((inputs?: Common_Just_MeInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Just_MeInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_common_just_me(inputs)
	return en_common_just_me(inputs)
});